import styled, { css } from 'styled-components';
import ShipperOrderRow from './ShipperOrderRow';

const openedStyles = () =>
  css`
    &__opened {
      &:before {
        border-width: 0 3px 4px 3px;
        border-color: transparent transparent var(--primary900) transparent;
      }
    }
  `;

export default styled(ShipperOrderRow)`
  margin-bottom: 0.8rem;

  &:last-child {
    margin-bottom: 0;
  }

  .shipper-order-row {
    display: flex;
    margin-bottom: 0.8rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid var(--grey100);

    &__last {
      margin-bottom: 0;
      border-bottom: 0;
    }

    &__load-info {
      display: flex;
      width: 200px;
    }

    &__indicator {
      margin-right: 0.8rem;
    }

    &__load {
      flex: 1;
    }

    &__order-id {
      margin-left: 1.6rem;
      flex: 1;
    }
  }

  .shipper-order-info {
    background-color: var(--grey100);
    margin-bottom: 1.6rem;
    padding: 0.8rem;

    .info-parent {
      margin-bottom: 0.8rem;
      &.no-margin {
        margin-bottom: 0;
      }
    }

    .info-title {
      color: var(--grey700);
    }
  }

  .shipper-order-times {
    font-weight: bold;
  }

  .dropdown-button {
    background: none;
    padding: 0;
    margin: 0;
    display: flex;
    width: 1.8rem;
    height: 1.8rem;
    align-items: center;
    justify-content: center;
    border: 0;
    cursor: pointer;

    &:before {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 4px 3px 0 3px;
      border-color: var(--primary900) transparent transparent transparent;
    }

    ${openedStyles}
  }
`;
